"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _params = require("hub-http/helpers/params");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _Categories = _interopRequireDefault(require("./constants/Categories"));

var _DesignAssetTypes = _interopRequireDefault(require("./constants/DesignAssetTypes"));

var _enviro = _interopRequireDefault(require("enviro"));

var _legacyHubspotBenderContext = require("legacy-hubspot-bender-context");

var _Domains = require("./constants/Domains");

var SITE_PAGE_SUBCATEGORIES = ['site_page', 'mab_site_page_master', 'mab_site_page_variant']; // Used to allow returning to original page whne navigating to a settings page.

var ESHREF_PARAM = "eschref=" + encodeURIComponent(window.location.pathname);
var Routes = {
  gates: null,
  init: function init(nextGates) {
    Routes.gates = nextGates;
  },
  isUngated: function isUngated(gateName) {
    if (!Array.isArray(Routes.gates)) {
      throw new Error('Routes needs to be initialized with an array of gates before using');
    }

    return Routes.gates.indexOf(gateName) > -1;
  },
  dashboard: function dashboard(categoryId, subcategoryId, parentId) {
    var category = _Categories.default[categoryId];
    var slug = category.api_slug;

    if (['site_page', 'landing_page', 'blog_post'].includes(category.field_name) && this.isUngated('cms-control-center')) {
      if (category.field_name === 'site_page' || SITE_PAGE_SUBCATEGORIES.includes(subcategoryId)) {
        return "/website/" + _hubspot.default.get() + "/pages/site";
      } else if (category.field_name === 'landing_page') {
        return "/website/" + _hubspot.default.get() + "/pages/landing";
      } else if (category.field_name === 'blog_post') {
        var baseUrl = "/website/" + _hubspot.default.get() + "/blog/posts";
        return parentId ? baseUrl + "?blog=" + parentId : baseUrl;
      }

      return "/website/" + _hubspot.default.get();
    }

    if (SITE_PAGE_SUBCATEGORIES.includes(subcategoryId)) {
      slug = _Categories.default.site_page.api_slug;
    }

    if (category.field_name === 'blog_post') {
      return Routes.blogDashboard(parentId);
    }

    if (category.field_name === 'email') {
      return Routes.emailDashboard();
    } else if (category.field_name === 'landing_page') {
      return Routes.pagesDashboard(categoryId, subcategoryId);
    }

    return "/content/" + _hubspot.default.get() + "/" + slug;
  },
  pagesDashboard: function pagesDashboard(categoryId, subcategoryId) {
    var pagesUrlSlug = SITE_PAGE_SUBCATEGORIES.includes(subcategoryId) ? 'site' : 'landing';
    return "/pages/" + _hubspot.default.get() + "/manage/" + pagesUrlSlug;
  },
  blogDashboard: function blogDashboard(contentGroupId) {
    if (contentGroupId) {
      return "/blog/" + _hubspot.default.get() + "/blogs/" + contentGroupId;
    }

    return "/blog/" + _hubspot.default.get();
  },
  blogImporter: function blogImporter() {
    return "/content/" + _hubspot.default.get() + "/blog-import";
  },
  emailDashboard: function emailDashboard() {
    return "/email/" + _hubspot.default.get() + "/manage";
  },
  // categoryId can be category_id int or python's Category.field_name (email|blog_post|landing_page)
  edit: function edit(contentId, categoryId) {
    return Routes.inpageEdit(contentId, categoryId);
  },
  editDragDropEmail: function editDragDropEmail(contentId) {
    return "/email/" + _hubspot.default.get() + "/edit-dd/" + contentId;
  },
  inpageEdit: function inpageEdit(contentId, categoryId) {
    var category = _Categories.default[categoryId];

    switch (category.field_name) {
      case 'blog_post':
        return "/blog/" + _hubspot.default.get() + "/edit-beta/" + contentId;

      case 'email':
        return "/email/" + _hubspot.default.get() + "/edit-beta/" + contentId;

      default:
        return "/content/" + _hubspot.default.get() + "/edit/" + contentId;
    }
  },
  details: function details(contentId, categoryId, subcategory) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      tab: 'performance'
    },
        _ref$tab = _ref.tab,
        tab = _ref$tab === void 0 ? 'performance' : _ref$tab;

    var category = _Categories.default[categoryId];

    if (category.field_name === 'unmapped') {
      return "/content-detail/" + _hubspot.default.get() + "/external-page/" + contentId + "/optimization";
    } else if (['site_page', 'landing_page', 'blog_post'].includes(category.field_name)) {
      var slugSource = SITE_PAGE_SUBCATEGORIES.includes(subcategory) ? _Categories.default['site_page'] : category;
      return "/content-detail/" + _hubspot.default.get() + "/" + slugSource.slug_singular + "/" + contentId + "/" + tab;
    } else if (category.field_name === 'email') {
      var stringifiedParams = (0, _params.stringify)(params);
      var urlParamsString = stringifiedParams !== '' ? "?" + stringifiedParams : '';
      return "/email/" + _hubspot.default.get() + "/details/" + contentId + "/" + tab + urlParamsString;
    } else if (category.field_name === 'knowledge_article') {
      return "/knowledge/" + _hubspot.default.get() + "/insights/article/" + contentId + "/" + tab;
    }

    return "/content-detail/" + _hubspot.default.get() + "/landing-page/" + contentId + "/" + tab;
  },
  staging: function staging() {
    return "/content/" + _hubspot.default.get() + "/staging";
  },
  stagingBeta: function stagingBeta(domainId) {
    var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/manage';
    return this.staging(domainId, route);
  },
  cta: function cta() {
    return "/cta/" + _hubspot.default.get();
  },
  ctaDetails: function ctaDetails(placementGuid) {
    return "/cta/" + _hubspot.default.get() + "/" + placementGuid;
  },
  ctaSmartRules: function ctaSmartRules(placementGuid) {
    return "/content/" + _hubspot.default.get() + "/cta/" + placementGuid;
  },
  create: function create(categoryId, subcategory) {
    var category = SITE_PAGE_SUBCATEGORIES.includes(subcategory) ? _Categories.default.site_page : _Categories.default[categoryId];

    if (category.slug_singular === 'blog-post') {
      throw new Error('Create page only used for pages & emails');
    }

    var createUrl = "/content/" + _hubspot.default.get() + "/create/" + category.slug_singular;

    if (category.slug_singular !== 'email' && this.isUngated('marketing-starter-landing-pages-beta')) {
      return createUrl + "/starter";
    }

    return createUrl;
  },
  createNew: function createNew(categoryId, subcategory, name, templatePath) {
    /* Create new only available in create-beta */
    var portalId = _hubspot.default.get();

    var category = subcategory === 'landing_page' ? _Categories.default.landing_page : _Categories.default[categoryId];

    if (category.slug_singular === 'blog-post') {
      throw new Error('Create page only used for pages & emails');
    }

    return "/content/" + portalId + "/create/" + category.slug_singular + "/new?name=" + name + "&templatePath=" + templatePath;
  },
  settings: function settings(subsection) {
    var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var portalId = _hubspot.default.get();

    var baseURL = "/settings/" + portalId + "/";

    switch (subsection) {
      case 'email':
        {
          var emailBase = baseURL + "marketing/email/";

          switch (tab) {
            case 'frequency':
              return emailBase + "frequency";

            case 'subscriptions':
              return emailBase + "subscriptions";

            default:
              return emailBase;
          }
        }

      case 'blog':
        {
          return baseURL + "website/blogs";
        }

      case 'publishing':
        {
          return baseURL + "website/pages";
        }

      case 'users':
        return baseURL + "users";

      case 'domains':
        return "/domains/" + portalId;

      case 'themes':
        return baseURL + "website/themes";

      default:
        return baseURL;
    }
  },
  systemPagesSettings: function systemPagesSettings(domain) {
    var basePagesUrl = Routes.settings('publishing');

    var __domain = domain || "all-domains";

    return basePagesUrl + "/" + __domain + "/system-pages?" + ESHREF_PARAM;
  },
  logoSettings: function logoSettings(domain) {
    var portalId = _hubspot.default.get();

    var __domain = domain || "all-domains";

    return "/settings/" + portalId + "/website/pages/" + __domain + "/branding?" + ESHREF_PARAM;
  },
  blogSpecificSettings: function blogSpecificSettings(blogId) {
    return Routes.settings('blog') + "/" + blogId + "?" + ESHREF_PARAM;
  },
  advancedMenuSettings: function advancedMenuSettings(menuId, redirectUrl) {
    var basePath = "/menus/" + _hubspot.default.get() + "/edit/" + menuId;

    if (redirectUrl) {
      return basePath + "?redirectUrl=" + encodeURIComponent(redirectUrl);
    }

    return basePath;
  },
  advancedMenuAddPage: function advancedMenuAddPage(pageId) {
    return "/content/" + _hubspot.default.get() + "/settings/menus/add-page?contentId=" + pageId + "&" + ESHREF_PARAM;
  },
  designManager: function designManager(assetId, assetType) {
    var route = "/design-manager/" + _hubspot.default.get();

    if (assetId && assetType) {
      var path;

      switch (assetType) {
        case _DesignAssetTypes.default.LAYOUT:
        case _DesignAssetTypes.default.GLOBAL_GROUP:
          {
            path = "templates/" + assetId;
            break;
          }

        case _DesignAssetTypes.default.TEMPLATE:
          {
            path = "code/" + assetId;
            break;
          }

        case _DesignAssetTypes.default.CUSTOM_WIDGET:
          {
            path = "modules/" + assetId;
            break;
          }

        case _DesignAssetTypes.default.GLOBAL_WIDGET:
          {
            path = "global-modules/" + assetId;
            break;
          }

        default:
          {
            throw new Error("Invalid Design Manager assetType provided. Received '" + assetType + "'.");
          }
      }

      route = route.concat("/" + path);
    }

    return route;
  },
  globalContent: function globalContent(moduleId) {
    if (moduleId) {
      return Routes.designManager(moduleId, _DesignAssetTypes.default.GLOBAL_WIDGET);
    }

    if (Routes.isUngated('DesignManagerUI:GlobalContent:Redirect')) {
      return Routes.designManager() + "?referrer=global-content";
    }

    return "/content/" + _hubspot.default.get() + "/global-content";
  },
  fileManager: function fileManager(folderPath) {
    var basePath = "/file-manager-beta/" + _hubspot.default.get();

    if (folderPath) {
      var path = folderPath.replace(/^\//, '');
      return basePath + "/folder/" + path;
    }

    return basePath;
  },
  hubdb: function hubdb() {
    return "/hubdb/" + _hubspot.default.get();
  },
  hubdbTable: function hubdbTable(tableId) {
    return this.hubdb() + "/table/" + tableId;
  },
  workflows: function workflows(workflowId) {
    var workflowType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'WORKFLOWS';

    if (workflowType === 'AUTOMATION_PLATFORM') {
      return "/workflows/" + _hubspot.default.get() + "/platform/flow/" + workflowId + "/edit";
    }

    return "/contacts/" + _hubspot.default.get() + "/automation/flow/" + workflowId + "/edit/";
  },
  workflowsDashboard: function workflowsDashboard() {
    return "/contacts/" + _hubspot.default.get() + "/automation";
  },
  contact: function contact(vid) {
    return "/contacts/" + _hubspot.default.get() + "/contact/" + vid;
  },
  deal: function deal(dealId) {
    return "/contacts/" + _hubspot.default.get() + "/deal/" + dealId;
  },
  forms: function forms(formId, redirectUrl) {
    var basePath = "/forms/" + _hubspot.default.get() + "/editor/" + formId + "/edit/form";

    if (redirectUrl) {
      return basePath + "?isExternalEditor=cos&redirectUrl=" + encodeURIComponent(redirectUrl);
    }

    return basePath;
  },
  salesforceCampaigns: function salesforceCampaigns() {
    return "/integrations-beta/" + _hubspot.default.get() + "/your-integrations/salesforce";
  },
  domainManager: function domainManager() {
    return "/domains/" + _hubspot.default.get();
  },
  leadFlowFollowup: function leadFlowFollowup(leadFlowId) {
    return "/lead-flows/" + _hubspot.default.get() + "/edit/" + leadFlowId + "/follow-up";
  },
  formFollowup: function formFollowup(formId) {
    return "/forms/" + _hubspot.default.get() + "/editor/" + formId + "/edit/followUp";
  },
  marketplace: function marketplace(urlToken) {
    var marketplaceRoute = "/marketplace/" + _hubspot.default.get();

    return urlToken ? marketplaceRoute + "/products/" + urlToken : marketplaceRoute;
  },
  marketingHubPricingPage: function marketingHubPricingPage() {
    return "/pricing/" + _hubspot.default.get() + "/products/marketing";
  },
  compareMarketingProducts: function compareMarketingProducts(product) {
    var portalId = _hubspot.default.get();

    var queryString = '';

    if (product) {
      queryString = "?product=" + product;
    }

    return "/browse/" + portalId + "/compare/marketing" + queryString;
  },
  accountSummary: function accountSummary() {
    var portalId = _hubspot.default.get();

    return "/account-and-billing/" + portalId + "/products";
  },
  additionalContact: function additionalContact() {
    var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var portalId = _hubspot.default.get();

    return "/pricing/" + portalId + "/confirm-contacts" + queryParams;
  },
  campaignDetails: function campaignDetails(campaignId) {
    var portalId = _hubspot.default.get();

    return "/campaigns/" + portalId + "/" + campaignId;
  },
  goToWebinar: function goToWebinar() {
    return "/integrations-beta/" + _hubspot.default.get() + "/your-integrations/gotowebinar";
  },
  list: function list(listId) {
    return "/contacts/" + _hubspot.default.get() + "/lists/" + listId;
  },
  lists: function lists() {
    // Not lists UI but CRM contact filter view
    return "/contacts/" + _hubspot.default.get() + "/contacts/list/view/all";
  },
  newList: function newList() {
    return "/contacts/" + _hubspot.default.get() + "/lists/create";
  },
  getPreviewDomain: function getPreviewDomain() {
    var env = _enviro.default.getShort('preview');

    if (env !== 'local') {
      return _Domains.PREVIEW_DOMAINS[env];
    }

    try {
      return localStorage.getItem('PREVIEW_DOMAIN') || _Domains.PREVIEW_DOMAINS[env];
    } catch (e) {
      return _Domains.PREVIEW_DOMAINS[env];
    }
  },
  getPreviewUrl: function getPreviewUrl(contentId, extraParams) {
    var env = _enviro.default.getShort('preview');

    var params = (0, _extends2.default)({
      portalId: _hubspot.default.get(),
      _preview: true,
      cacheBust: Date.now()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();

    if (env === 'local') {
      return "https://" + previewDomain + "/cos-rendering/v1/public/_hcms/preview/content/" + contentId + "?" + (0, _params.stringify)(params);
    }

    return "https://" + previewDomain + "/_hcms/preview/content/" + contentId + "?" + (0, _params.stringify)(params);
  },
  getVideoPreviewUrl: function getVideoPreviewUrl(playerId, extraParams) {
    var params = (0, _extends2.default)({
      portalId: _hubspot.default.get()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();
    return "https://" + previewDomain + "/content-rendering/v1/internal/preview/player/" + playerId + "?" + (0, _params.stringify)(params);
  },
  getPreviewSidebarUrl: function getPreviewSidebarUrl(contentId, extraParams) {
    var env = _enviro.default.getShort('preview');

    var params = (0, _extends2.default)({
      portalId: _hubspot.default.get(),
      _preview: true,
      cacheBust: Date.now()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();

    if (env === 'local') {
      return "https://" + previewDomain + "/cos-rendering/v1/public/_hcms/preview/content/" + contentId + "/sidebar?" + (0, _params.stringify)(params);
    }

    return "https://" + previewDomain + "/_hcms/preview/content/" + contentId + "/sidebar?" + (0, _params.stringify)(params);
  },
  themes: function themes() {
    return this.settings('themes') + "?" + ESHREF_PARAM;
  },
  themePreview: function themePreview(themePath) {
    return "/theme-previewer/" + _hubspot.default.get() + "/edit/" + themePath;
  },
  globalContentEditorEmbed: function globalContentEditorEmbed(globalContentId, params) {
    var _ref2 = params || {},
        assetId = _ref2.assetId;

    if (!(globalContentId || assetId)) {
      throw new Error('Global content or asset ID required to load embedded editor.');
    }

    var route = "/global-content-editor/" + _hubspot.default.get() + "/edit-embed";
    if (globalContentId) route = route + "/" + globalContentId;
    if (params) route = route + "?" + (0, _params.stringify)(params);
    return route;
  },
  globalContentEditor: function globalContentEditor(globalContentId, params) {
    var _ref3 = params || {},
        assetId = _ref3.assetId;

    if (!(globalContentId || assetId)) {
      throw new Error('Global content or asset ID required to load editor.');
    }

    var route = "/global-content-editor/" + _hubspot.default.get() + "/edit";
    if (globalContentId) route = route + "/" + globalContentId;
    if (params) route = route + "?" + (0, _params.stringify)(params);
    return route;
  },
  getContentIconsUrl: function getContentIconsUrl(set, iconName, style) {
    return _legacyHubspotBenderContext.bender.staticDomainPrefix + "/content-icons-ui/" + _legacyHubspotBenderContext.bender.depVersions['content-icons-ui'] + "/images/" + set + "/" + iconName + "/" + style + ".svg";
  }
};
var _default = Routes;
exports.default = _default;
module.exports = exports.default;